import * as React from 'react';
import { createElement } from 'react';
import { Select, Divider, Search, Box } from '@alifd/next';
import './index.scss';
import { entityDataUtil, entityMetadataUtil } from 'oadp-common';
export class OadpAttributeRefer extends React.Component {
    constructor(props) {
        super(props);
        this.initDataSoure = async () => {
            const { attribute, value } = this.props;
            console.log('initDataSoure this.props', this.props);
            try {
                if (!this.state.needInitDataSource) {
                    return;
                }
                if (!attribute) {
                    console.error('attribute is required');
                    return;
                }
                const attributeWithRefer = await entityMetadataUtil.asyncSelectAttributeWithReferById(attribute);
                if (!attributeWithRefer) {
                    console.error('attributeWithRefer is required');
                    return;
                }
                this.setState({
                    attributeWithRefer: attributeWithRefer,
                    needInitDataSource: false
                });
                if (!value) {
                    console.warn('value is required');
                    return;
                }
                const response = await entityDataUtil.asyncSelectOneByPrimaryKey(attributeWithRefer.referEntity.logicalName, attributeWithRefer.referAttribute.logicalName, value);
                if (!response.data) {
                    console.error('response.data is required', response);
                    return;
                }
                const dataSourceArray = [];
                dataSourceArray.push({
                    label: response.data.name,
                    value: response.data[attributeWithRefer.referAttribute.logicalName],
                });
                this.setState({
                    dataSource: dataSourceArray
                });
            }
            catch (error) {
                console.error("加载初始数据时发生错误：", error);
            }
        };
        this.handleFilterRuleToCondition = (filterCondition, field) => {
            console.log('handleFilterRuleToCondition begin with filterCondition', filterCondition, field);
            if (!filterCondition)
                return;
            let newFilterCondition = { ...filterCondition };
            if (filterCondition.operator === 'or' || filterCondition.operator === 'and') {
                newFilterCondition.value = filterCondition.value.map(item => this.handleFilterRuleToCondition(item, field));
            }
            else {
                if (filterCondition.valueType === 'ATTRIBUTE') {
                    const attributeValueLogicalName = filterCondition.value;
                    newFilterCondition.value = field.getValue(attributeValueLogicalName);
                }
            }
            console.log('handleFilterRuleToCondition end with newFilterCondition', newFilterCondition);
            return newFilterCondition;
        };
        this.handleFocus = async () => {
            this.setState({ searchValue: '' });
            const { attribute, filterRule, field } = this.props;
            console.log('handleFocus begin with ', attribute, filterRule, field);
            const attributeWithRefer = this.state.attributeWithRefer;
            let condition = null;
            if (filterRule) {
                condition = this.handleFilterRuleToCondition(filterRule, field);
            }
            console.log('handleFocus condition', condition);
            const query = {
                "model": attributeWithRefer.referEntity.logicalName,
                condition,
                "orderBy": [
                    {
                        "attribute": "updateAt",
                        "operator": "desc"
                    }
                ],
                "pageNum": 1,
                "pageSize": 1000
            };
            const response = await entityDataUtil.asyncSelectPageListByCondition(attributeWithRefer.referEntity.logicalName, query);
            console.log('response', response);
            const dataSourceArray = [];
            response.data.list.forEach((item) => {
                dataSourceArray.push({
                    label: item.name,
                    value: item[attributeWithRefer.referAttribute.logicalName],
                });
            });
            this.setState({
                dataSource: dataSourceArray
            });
            console.log("dataSourceArray return", dataSourceArray);
        };
        this.handleSearch = async (value) => {
            const searchValue = value;
            if (searchValue === '')
                return;
            const attributeWithRefer = this.state.attributeWithRefer;
            console.log('Select onFocus begin  ', attributeWithRefer.referEntity.logicalName, searchValue);
            const condition = {
                "model": attributeWithRefer.referEntity.logicalName,
                "condition": {
                    "attribute": "name",
                    "operator": "like",
                    "value": searchValue
                },
                "orderBy": [
                    {
                        "attribute": "updateAt",
                        "operator": "desc"
                    }
                ],
                "pageNum": 1,
                "pageSize": 1000
            };
            const response = await entityDataUtil.asyncSelectPageListByCondition(attributeWithRefer.referEntity.logicalName, condition);
            console.log('response', response);
            const dataSourceArray = [];
            response.data.list.forEach((item) => {
                dataSourceArray.push({
                    label: item.name,
                    value: item[attributeWithRefer.referAttribute.logicalName],
                });
            });
            this.setState({
                dataSource: dataSourceArray
            });
            console.log("dataSourceArray return", dataSourceArray);
        };
        this.state = {
            dataSource: [],
            needInitDataSource: true,
            searchValue: '',
            attributeWithRefer: null,
        };
    }
    componentDidMount() {
    }
    render() {
        const { name, attribute, value, defaultValue, field, label, placeholder, size, mode, hasBorder, hasArrow, hasClear, required, readOnly, disabled, ...otherProps } = this.props;
        const menuProps = {
            focusable: false,
            header: (createElement(Box, { style: { padding: '0 4px', textAlign: 'center' } },
                createElement(Box, { style: { paddingBottom: 4 } },
                    createElement(Search, { shape: "simple", onSearch: this.handleSearch, style: { width: '100%' }, placeholder: "\u8F93\u5165\u5173\u952E\u5B57\u67E5\u8BE2", hasClear: true })),
                createElement(Divider, { style: { marginTop: 0, marginBottom: 4 } }))),
            footer: (createElement(Box, { style: { padding: '0 4px', textAlign: 'center' } },
                createElement(Divider, { style: { marginBottom: 0, marginTop: 4 } }))),
        };
        this.initDataSoure();
        return (createElement(Select, Object.assign({ name: name, value: value, dataSource: this.state.dataSource, onFocus: this.handleFocus, onBlur: () => this.setState({ searchValue: '' }), showSearch: true, onSearch: this.handleSearch, filterLocal: false, popupAutoFocus: true, menuProps: menuProps, defaultValue: defaultValue, label: label, placeholder: placeholder, size: size, mode: mode, hasBorder: hasBorder, hasArrow: hasArrow, hasClear: hasClear, required: required, readOnly: readOnly, disabled: disabled }, otherProps)));
    }
}
;
export default OadpAttributeRefer;
